import i18n from 'i18next'

function formatCurrency(
  amount: number,
  { maximumFractionDigits = 2 } = {},
): string {
  const locale = i18n.language

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: i18n.t('intl.currency'),
    maximumFractionDigits,
  }).format(amount)
}

export { formatCurrency }
